// Firebase setup for Auth (email/password) and Firestore.
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBAwo2M_28aXjywJv8NBuEbVPZpSBA_WlA",
  authDomain: "my-school-event-5a9b2.firebaseapp.com",
  databaseURL: "https://my-school-event-5a9b2-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "my-school-event-5a9b2",
  storageBucket: "my-school-event-5a9b2.firebasestorage.app",
  messagingSenderId: "575607372842",
  appId: "1:575607372842:web:57e2422e2c2b90a2ccd753",
  measurementId: "G-6KK18JP28L"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);

export default app;
